var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidepassword1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39035 4.45069L1.04525 2.10559L2.10591 1.04492L16.9552 15.8941L15.8945 16.9549L13.412 14.4724C12.136 15.2814 10.6229 15.7499 9.00023 15.7499C4.95609 15.7499 1.59161 12.8401 0.88623 8.99991C1.21374 7.21688 2.11449 5.63444 3.39035 4.45069ZM11.0683 12.1286L9.97028 11.0306C9.6765 11.1712 9.34755 11.2499 9.00023 11.2499C7.75755 11.2499 6.7502 10.2425 6.7502 8.99991C6.7502 8.65251 6.82892 8.32356 6.96947 8.02979L5.8715 6.93184C5.47886 7.52466 5.2502 8.23559 5.2502 8.99991C5.2502 11.071 6.92913 12.7499 9.00023 12.7499C9.76448 12.7499 10.4754 12.5212 11.0683 12.1286ZM5.98085 2.81987C6.91595 2.45195 7.93448 2.24988 9.00023 2.24988C13.0443 2.24988 16.4088 5.1597 17.1142 8.99991C16.88 10.2746 16.3529 11.4469 15.6051 12.4441L12.7103 9.54929C12.7366 9.36996 12.7502 9.18651 12.7502 8.99991C12.7502 6.92881 11.0713 5.24988 9.00023 5.24988C8.81355 5.24988 8.6301 5.26351 8.45078 5.28983L5.98085 2.81987Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepassword1);
export default __webpack_public_path__ + "static/media/hidepassword1.a7ae4598a1d5a8659dda0a24da116178.svg";
export { ForwardRef as ReactComponent };